import React from 'react'

import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'

import { buildThemeFromColor } from '~/src/UI/Theme/mui'

import EntityPrimaryColor from './EntityPrimaryColor'

const defaultTransform = primary => buildThemeFromColor(primary)

const EntityThemeProvider = ({ children, primary, themeTransform = defaultTransform }) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme => themeTransform(primary, theme)}>
      {children}
    </ThemeProvider>
  </StyledEngineProvider>
)

const EntityThemeWrapper = ({ children, ...entityPrimaryColorProps }) => (
  <EntityPrimaryColor {...entityPrimaryColorProps}>
    <EntityThemeProvider>{children}</EntityThemeProvider>
  </EntityPrimaryColor>
)

const Memoized = React.memo(EntityThemeWrapper)

export default Memoized
